<template>
  <div :class="[backgroundColor]">
    <div class="flex-mid m-auto">
      <relationship-mapping />
    </div>
  </div>
</template>

<script>
export default {
  // name: "relationship-mapping",
  components: {
    relationshipMapping: require("./members/members-components/relationship-mapping")
      .default
  },
  data() {
    return {
      themeMode: "light"
    };
  },
  computed: {
    backgroundColor() {
      switch (this.themeMode) {
        case "light":
          return "light";
        case "dark":
          return "dark";
        default:
          return "light";
      }
    }
  },
  mounted() {
    if (
      this.$router.currentRoute.path === "/relationship-mapping" &&
        this.$router.currentRoute.query.mode === "dark"
    ) {
      this.themeMode = "dark";
    }
  }
};
</script>

<style lang="scss" scoped>
.light, .dark {
  min-height: 400px;
}
.light {
  background-color: #fff;
}
.dark {
  background-color: #242424;
}
</style>